import { Component, Injector, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';

// components
import { FullListComponent } from '../../../shared/components/full-list/full-list.component';
import { ProductClockFaceComponent } from './product-clockface.component';

// models
import { ProductClockFace, ProductClockFaceValueSourceEnum } from '../../../shared/models/product';

// services
import { ProductService } from '../../shared/services/product.service';

@Component({
  selector: 'product-clockfaces-component',
  templateUrl: './product-clockfaces.component.html'
})
export class ProductClockFacesComponent extends FullListComponent<ProductClockFace, ProductClockFaceComponent> implements OnInit, OnDestroy {

  @ViewChild('confirmation') confirmation: any;
  @ViewChild('details') detailsComponent: ProductClockFaceComponent;

  @Input('type') type: number;

  auctionClusterId: number;
  productId: number;

  rtlEnabled = localStorage.getItem('last-selected-language-direction') ? JSON.parse(localStorage.getItem('last-selected-language-direction')) : false;
  private _subscription: Subscription;

  constructor(
    protected injector: Injector,
    private dataService: ProductService,
  ) {
    super(injector, ProductClockFace);
    this._subscription = this.language.direction.subscribe(dir => {
      this.rtlEnabled = dir;
    });
  }

  ngOnInit() {
    this.setTranslations('PRODUCT.CLOCKFACE');
    this.auctionClusterId = +this.route.snapshot.params['id'];
    this.productId = +this.route.snapshot.params['productId'];

    this.dataService.getProductClockFaces(this.auctionClusterId, this.productId, this.type)
      .subscribe((res: Array<ProductClockFace>) => {
        this.items = res;
      },
        error => {
          this.errorService.show(error);
        });
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this._subscription.unsubscribe();
  }

  add() {
    this.detailsComponent.modalTitle = this.translations.ADD_NEW;
    this.detailsComponent.open(this.items, null, this.type);
  }

  edit = (e: any) => {
    if (e.row !== undefined && e.event) {
      e.event.stopPropagation();
    }
    const id = e.row !== undefined ? e.row.data.productClockFaceId : e.data.productClockFaceId;
    this.detailsComponent.modalTitle = this.translations.EDIT;
    this.detailsComponent.open(this.items, id, this.type);
  }

  deleteItem = (e: any) => {
    if (e.event) {
      e.event.stopPropagation();
    }
    this.itemIdToDelete = e.row.data.productClockFaceId;
    this.confirmation.opened = true;
  }

  deleteSelected() {
    this.items = this.items.filter((_) => _.productClockFaceId !== this.itemIdToDelete);
    this.save();
  }

  onDetailsClosed(clockFace: ProductClockFace) {
    const existingIndex = this.items.findIndex(item => item.productClockFaceId === clockFace.productClockFaceId);
    if (existingIndex !== -1) {
      this.items[existingIndex] = clockFace;
    } else {
      this.items.push(clockFace);
    }
    
    this.save();
  }

  save() {
    this.dataService.saveProductClockFaces(this.auctionClusterId, this.productId, this.type, this.items)
      .subscribe((res: Array<ProductClockFace>) => {
        this.items = res;
      },
        error => {
          this.errorService.show(error);
        });
  }
}
